import $ from 'jquery';

export default function googleCalendar() {

    let mql = window.matchMedia("(max-width: 640px)");
    mql.addListener(manipulateIframeSrc);
    manipulateIframeSrc(mql);

    function manipulateIframeSrc(mql) {
        let $iFrame = $('.rich-text').find('iframe');
        
        $iFrame.each(function(index, element) {
            let iframeSrc = $(this).attr('src'),
                regex = /\/calendar\/(embed|htmlembed)/g,
                modeRegex = /\&mode=AGENDA/g;
            if(regex.test(iframeSrc) === true) { 
                if (mql.matches) {
                    let mobileSrc = iframeSrc + "&mode=AGENDA";
                    $(this).attr('src', mobileSrc);
                
                } else {
                    if(modeRegex.test(iframeSrc) === true) {
                        let desktopSrc = iframeSrc.replace('&mode=AGENDA','');
                        $(this).attr('src', desktopSrc);
                    }
                    else {
                        $(this).attr('src', iframeSrc);
                    }
                }
            }
        });

    }
}
